import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { debounce } from './utils/tickers'
import { html } from './utils/environment';
import config from './config'
import { isFontLoadingAPIAvailable, loadFonts } from './utils/fonts';

const app = new modular({
    modules: modules,
});

window.addEventListener('load', () => {
    const $style = document.getElementById('theme-app-css');

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
});

export const EAGER_FONTS = [
    { family: 'Akkurat Sub', style: 'normal', weight: 'normal' },
    { family: 'Akkurat Sub', style: 'italic', weight: 'normal' },
    { family: 'Akkurat Sub', style: 'normal', weight: 'bold' },
    { family: 'Akkurat Sub', style: 'italic', weight: 'bold' },
];

function init() {
    globals();

    const setProperty = ($el, property, value) => {
        $el.style.setProperty(property, value)
    }

    const $footer = document.getElementById('footer')
    const setFooterHeight = () => {
        if(config.IS_MOBILE || !$footer) {
            return
        }
        setProperty(html, '--footer-height', `${$footer.offsetHeight}px`)
    }

    if(config.IS_DESKTOP && $footer) {
        $footer.classList.add('-sticky')
        setFooterHeight()
    }

    // Bind window resize event
    const resizeEndEvent = new CustomEvent('resizeEnd')
    window.addEventListener('resize', () => {
        setProperty(html, '--vw', `${document.documentElement.clientWidth * 0.01}px`)
        debounce(() => {
            window.dispatchEvent(resizeEndEvent)
            setFooterHeight()
        }, 200, false)
    })

    // Check mobile state
    if (config.IS_MOBILE) {
        setProperty(html, '--vh', `${document.documentElement.clientHeight * 0.01}px`)
        html.classList.add(config.CSS_CLASS.MOBILE)
    } else {
        html.classList.add(config.CSS_CLASS.DESKTOP)
    }

    setProperty(html, '--vw', `${document.documentElement.clientWidth * 0.01}px`)

    app.init(app);

    const loaderAnimation = new Promise(resolve => {

        const duration = config.IS_DEV ? 0 : 500
        let delay = new Date()
        delay = (delay - window.timestamp)
        delay = Math.max(0, duration - delay)

        setTimeout(() => {
            resolve()
        }, delay)
    })

    const fontsLoad = new Promise(resolve => {

        /**
         * Eagerly load the following fonts.
         */
        if (isFontLoadingAPIAvailable) {
            loadFonts(EAGER_FONTS, config.IS_DEV).then((eagerFonts) => {
                // html.classList.add('fonts-loaded');

                if (config.IS_DEV) {
                    console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size);
                    console.group('State of eager fonts:')
                    eagerFonts.forEach((font) => console.log(font.family, font.style, font.weight, font.status/*, font*/))
                    console.groupEnd()
                    console.group('State of all fonts:')
                    document.fonts.forEach((font) => console.log(font.family, font.style, font.weight, font.status/*, font*/))
                    console.groupEnd()
                }
                resolve()
            });
        } else {
            resolve()
        }
    })

    Promise.all([loaderAnimation, fontsLoad]).then(() => {
        html.classList.add(config.CSS_CLASS.FIRST_LOADED);
        html.classList.add(config.CSS_CLASS.LOADED);
        html.classList.add(config.CSS_CLASS.READY);
        html.classList.remove(config.CSS_CLASS.LOADING);
    })
}
